import { render, staticRenderFns } from "./CtMmMemberForm.vue?vue&type=template&id=2b2de402&"
import script from "./CtMmMemberForm.vue?vue&type=script&lang=js&"
export * from "./CtMmMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports